import "./index.scss"
import list1 from "../../assets/list1.png"
import list2 from "../../assets/list2.png"
import list3 from "../../assets/list3.png"
import list4 from "../../assets/list4.png"

function Competitiveness() {
  const list = [
    {
      id: 1,
      icon: list1,
      title: "深度查找与挖掘能力",
      content: ["平台拥有强大的数据分析能力，能够深度查找和挖掘隐藏的财产线索，帮助客户发现可能被忽略的资产信息。", "利用先进的算法和模型，对海量数据进行快速处理和分析，提高查找效率。"]
    }, {
      id: 2,
      icon: list2,
      title: "智能跟踪功能",
      content: ["能够实时监控查询对象及其关联方的资产动态，确保客户及时掌握关键信息。通过关系网络分析，助力客户全面了解整体情况，提前洞察潜在风险，为决策提供有力支持。"]
    }, {
      id: 3,
      icon: list3,
      title: "实时更新与发现",
      content: ["平台实时更新数据，确保客户能够第一时间发现新的财产线索。", "通过对市场动态、行业政策等信息的实时监控，提前预警可能的资产变动，为客户争取更多时间。"]
    }, {
      id: 4,
      icon: list4,
      title: "详细的财产线索分析",
      content: ["提供详尽的财产线索分析报告，通过图表、数据可视化等方式，直观展示财产线索的关联性和变化趋势，便于客户理解。"]
    }
  ]
  return (
    <div className="competitiveness-container">
      <div className="subtitle">核心竞争力</div>
      <div className="title">CORE COMPETITIVENESS</div>
      <div className="competitiveness-info">
        {list.map((item, index) => {
          return (
            <div key={index} className="list-item">
              <div className="title-row">
                <img className="title-img" src={item.icon}></img>
                <span className="title">{item.title}</span>
              </div>
              <div className="content">
                {
                  item.content.map((content, contentIndex) => <div className="content-item" key={contentIndex}>{content}</div>
                  )
                }
              </div>
            </div>
          )
        })}
      </div>
    </div>
  )
}
export default Competitiveness